import React from 'react'

export const CreditsIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          fill={fill}
          d='M106.6,88.2c-17.4,0-31.6,14.1-31.6,31.6c0,17.4,14.1,31.6,31.6,31.6c17.4,0,31.6-14.1,31.6-31.6
            S124.2,88.2,106.6,88.2z M120.8,133.9c-6,4.7-10,5.1-11.9,5.4h-1.1l0,0c-10.9,0-16.9-7.1-19.1-13.8c-3.8-11.4,4.4-19.8,9.2-22.6
            l0.3-0.2c11.2-5.7,20.1,0,23.3,3.8c0.9,1.1,1.4,2.5,1.3,4c-0.2,1.4-0.8,2.8-1.9,3.6c-2.4,1.9-5.7,1.6-7.8-0.6
            c-0.3-0.5-3.8-4.1-9.7-1.1c-0.9,0.6-6,4.3-4.3,9.8c0.9,2.8,3.2,6.2,8.7,6.2l0,0c0.8-0.2,2.7-0.5,6.2-3.2c2.4-1.9,5.9-1.4,7.8,0.9
            l0,0C123.7,128.5,123.2,132,120.8,133.9z'
        />
        <path
          fill={fill}
          d='M79.1,67.7c16.3-0.5,29.1-14.2,28.6-30.5S93.5,8.1,77.2,8.6C60.9,9,48.1,22.8,48.5,39.1C49.2,55.4,62.8,68.2,79.1,67.7z'
        />
        <path
          fill={fill}
          d='M91.1,82.3c-11.6-1.9-30.1-1.3-43,5.4c-18.7,9.3-28.3,30.2-25.9,44.5c0.6,3.3,4.1,8.9,8.9,8.4l41.8,1.6c-4.3-6.5-6.8-14.2-6.8-22.5C65.9,102.9,76.4,88.3,91.1,82.3z'
        />
      </g>
    </svg>
  )
}

export const ReferencesIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill={fill}
        d='M61.1,19.9h83.6C144.4,11.2,137,8.6,128,8.6H36.7c-14.6,0-21.4,7.4-21.4,22.9v103.6
        c0,8.9,7.5,16.4,16.7,16.4h96c9.2,0,16.7-7.4,16.7-16.4V37.2H61.2c0,0,0,9.8,0,9.8v25.4c0,3-3.2,4.9-5.9,3.5l-8.9-6.5
        c-1.1-0.6-2.5-0.6-3.6,0L33.8,76c-2.7,1.3-5.9-0.6-5.9-3.5v-41c0-7.9,1.7-11.6,8.7-11.6'
      />
    </svg>
  )
}

export const QuoteIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          fill={fill}
          d='M144.8,47c-11.8-23-35.1-38-61-39.2c-5.4-0.2-10.1,4.1-10.4,9.5c-0.3,5.5,4,10.2,9.5,10.4
		c18.7,0.9,35.5,11.7,44.1,28.4c13.1,25.6,3,57.2-22.7,70.3c-25.6,13.1-57.2,3-70.3-22.7c-2.5-4.9-8.5-6.8-13.4-4.3
		c-2.4,1.2-4.1,3.3-4.9,5.8c-0.8,2.5-0.6,5.2,0.6,7.6c12.4,24.2,37.1,39.2,64.3,39.2c11.3,0,22.7-2.7,32.8-7.9
		C148.9,126,162.9,82.5,144.8,47z'
        />
        <path
          fill={fill}
          d='M23.3,86.1c0.1,0,0.3,0,0.4,0c3.8,0,7.4-1.4,10.3-3.9c2.9-2.6,4.5-6.3,4.4-10.2c0.1-4-1.5-7.8-4.3-10.4
		c-2.3-2.4-5.5-3.9-8.9-4.1c0.4-1.8,1.1-3.5,2.2-5c1.8-2.1,3.9-3.8,6.3-5.1c2.8-1.3,4.5-4.2,4.3-7.1c0.1-2-0.6-4-2-5.5
		c-1.5-1.5-3.6-2.3-5.5-2.2c-3.1,0-6.5,1.5-10.4,4.7c-3.9,3.3-7,7.4-9.1,12c-2.5,5.1-3.8,10.7-3.7,16.3c0,6.4,1.5,11.4,4.4,14.9
		c2.7,3.5,7,5.6,11.4,5.6C23.2,86.1,23.2,86.1,23.3,86.1z'
        />
        <path
          fill={fill}
          d='M48.2,80.5c2.7,3.7,7.2,5.9,11.6,5.8c0.2,0,0.3,0,0.5,0c3.8,0,7.4-1.4,10.2-4c2.8-2.6,4.4-6.2,4.4-10
		c0-0.1,0-0.2,0-0.2c0-7.5-5.6-13.7-13.1-14.5c0.4-1.8,1.1-3.5,2.2-5c1.7-2.1,3.8-3.9,6.1-5.1c2.7-1.3,4.4-3.9,4.4-6.9
		c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-1.9-0.7-3.7-2-5.2c-1.5-1.4-3.5-2.2-5.6-2.1c-2.8,0.2-5.5,1.2-7.7,2.8
		c-2.9,1.9-5.4,4.3-7.5,7.1c-2.4,3.1-4.3,6.6-5.6,10.4c-1.5,4-2.2,8.2-2.2,12.4c0,0.1,0,0.2,0,0.3C43.8,71.9,45.3,76.9,48.2,80.5z'
        />
      </g>
    </svg>
  )
}
